import { ChangeDetectionStrategy, Component, DestroyRef, inject, output, TemplateRef, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalRef, SiModalService } from '@siemens/element-ng/modal';
import { tap } from 'rxjs';
import { ConfirmModalResultEnum } from '../../../enums/confirm-modal.enum';

@Component({
    selector: 'tran-file-delete-modal',
    imports: [TranslatePipe],
    templateUrl: './file-delete-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileDeleteModalComponent {
    private readonly modalService = inject(SiModalService);
    private readonly destroyRef = inject(DestroyRef);

    public readonly fileDeleted = output<ConfirmModalResultEnum>();

    private readonly deleteFileModal = viewChild.required<TemplateRef<void>>('deleteFileModal');

    protected deleteFileModalRef?: ModalRef;

    protected readonly ConfirmModalResultEnum = ConfirmModalResultEnum;

    public onDelete(): void {
        this.deleteFileModalRef = this.modalService.show(this.deleteFileModal(), {
            class: 'modal-dialog-centered'
        });

        this.deleteFileModalRef.hidden
            ?.pipe(
                tap(reason => this.fileDeleted.emit(reason)),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }

    protected hideDeleteFileModal(reason: ConfirmModalResultEnum): void {
        this.deleteFileModalRef?.hide(reason);
    }
}
